import { LAYOUTS, POSITION, } from "@voltmoney/types";
import { ButtonTypeTokens, ButtonWidthTypeToken, ColorTokens, FontFamilyTokens, IconSizeTokens, IconTokens, SizeTypeTokens, StackAlignItems, StackJustifyContent, StackType, WIDGET, } from "@voltmoney/schema";
import { ROUTE } from "../../routes";
import { ACTION } from "./types";
import { GoToNumber } from "./actions";
import { Platform } from 'react-native';
import { getParameters } from "../../configs/uri-config-utils";
export const template = {
    layout: {
        id: ROUTE.CAROUSAL_PAGE,
        type: LAYOUTS.LIST,
        widgets: [
            { id: "spaceXL", type: WIDGET.SPACE },
            { id: "stackIcon", type: WIDGET.STACK },
            { id: "carousal", type: WIDGET.CAROUSAL },
            { id: "button", type: WIDGET.BUTTON, position: POSITION.ABSOLUTE_BOTTOM },
        ],
    },
    datastore: {
        spaceXL: { size: SizeTypeTokens.Size10 },
        stackIcon: {
            type: StackType.row,
            alignItems: StackAlignItems.center,
            justifyContent: StackJustifyContent.center,
            widgetItems: [{ id: "icon", type: WIDGET.ICON }],
        },
        icon: {
            name: IconTokens.VoltFull,
            size: IconSizeTokens.XXXXXXXXL,
        },
        space2: { size: SizeTypeTokens.XXL },
        carousal: {
            data: [
                {
                    id: "1",
                    image: 'https://volt-images.s3.ap-south-1.amazonaws.com/intro_first_image.png',
                    text: "Unlock cash from mutual fund savings in 5 mins",
                },
                {
                    id: "2",
                    image: 'https://volt-images.s3.ap-south-1.amazonaws.com/intro_second_image.png',
                    text: "Withdraw only what you need,\n and repay flexibly",
                },
                {
                    id: "3",
                    image: 'https://volt-images.s3.ap-south-1.amazonaws.com/intro_third_image.png',
                    text: "Let your savings grow",
                },
            ],
            textColor: ColorTokens.Black,
        },
        button: {
            fontFamily: FontFamilyTokens.Poppins,
            label: "Get started",
            type: ButtonTypeTokens.LargeFilled,
            width: ButtonWidthTypeToken.FULL,
            action: {
                type: ACTION.GOTO_PHONE,
                routeId: ROUTE.CAROUSAL_PAGE,
            },
        },
    },
};
export const carousalPageMF = {
    onLoad: async ({ instrumentTrack, addUseProperty }) => {
        if (Platform.OS === 'web') {
            const newUrl = window.location.href;
            const newParams = getParameters(newUrl);
            const platform = newParams?.platform;
            if (platform) {
                addUseProperty('x-appPlatform', platform);
            }
        }
        await instrumentTrack("ONBOARDING_PAGE_VIEWED");
        return Promise.resolve(template);
    },
    actions: {
        [ACTION.GOTO_PHONE]: GoToNumber,
    },
};
